<template>
<div class="newsDetailView" :loading="detailLoading" v-if="currentNews">
    <img class="headPic" :src="`/news_pic/v${volume}i${issue}.png`" />
    <div style="height: 3.5rem; width: 1px;" />
    <div class="infoLine">
        <img class="infoIcon" src="@/assets/news0.png" />
        <div style="width: 0.7rem; height: 1px;" />
        <div class="infoText">
            {{ currentNews.author }}
        </div>
        <div style="width: 5.1rem; height: 1px;" />
        <img class="infoIcon" src="@/assets/news1.png" />
        <div style="width: 0.7rem; height: 1px;" />
        <div class="infoText">
            {{ currentNews.date }}
        </div>
    </div>
    <div class="contentArea">
        <div
            v-for="(block, idx) in buildContentBlocks(currentNews.content)"
            :key="idx"
            :class="block.className"
        >
            <template v-if="block.type === 'unordered'">
                <div class="textIcon" />
            </template>
            {{ block.text }}
        </div>
    </div>
    <div style="height: 3.7rem; width: 1px;" />

</div>
</template>

<script>
export default {
	props: {
        volume: {
            type: String,
            required: true,
        },
        issue: {
            type: String,
            required: true,
        },
	},
	data() {
		return {
            detailLoading: false,
            currentNews: null,
		}
	},
	methods: {
        async loadNewsDetail(volume, issue) {
            this.detailLoading = true;
            this.currentNews = null;

            try {
                const res = await fetch(`/news/news_vol_${volume}.json?_=${Date.now()}`, {
                    cache: "no-store"
                });

                if (!res.ok) throw new Error(`HTTP ${res.status}`);

                const list = await res.json();

                const v = String(volume);
                const i = String(issue);

                const found = (list || []).find(n =>
                    String(n.volume) === v && String(n.issue) === i
                );

                if (!found) {
                    throw new Error(`找不到新闻：volume=${v}, issue=${i}`);
                }

                // ③ 写入状态
                this.currentNews = found;
                console.log(this.currentNews)
            } catch (e) {
                console.log(e)
            } finally {
                this.detailLoading = false;
            }
        },

        buildContentBlocks(content) {
            const list = Array.isArray(content) ? content : [];

            return list
            .filter(item => item && typeof item === 'object')
            .map(item => {
                const type = String(item.type || 'text');
                const value = item.value == null ? '' : String(item.value);

                // 你可以按喜好改 class 命名规则
                // 例如：news-title / news-text / news-unordered
                const className = `news-${type}`;

                // text 类型里可能有 \n，直接渲染成文本不会换行
                // 这里先原样保留；你可以用 CSS 给 .news-text 加 white-space: pre-line; 来显示换行
                return {
                    type,
                    className,
                    text: value,
                };
            });
        },
	},
	mounted() {
        this.loadNewsDetail(this.volume, this.issue);
	},
	watch: {
        volume(newVal, oldVal) {
            if (newVal!== oldVal) {
                this.loadNewsDetail(newVal, this.issue);
            }
        },
        issue(newVal, oldVal) {
            if (newVal!== oldVal) {
                this.loadNewsDetail(this.volume, newVal);
            }
        },
	},
}
</script>

<style lang="scss" scoped>
.newsDetailView {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    box-shadow: 0px 0.3rem 3.3rem 0px rgba(51, 51, 51, 0.05);

    .headPic {
        width: 100%;
        height: 25.8rem;
        object-fit: cover;
    }
    .infoLine {
        width: calc(100% - 6.6rem);
        margin: 0rem 3.3rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-end;

        .infoIcon {
            width: 1.7rem;
            height: 1.7rem;
            display: inline-block;
        }
        .infoText {
            font-size: 1.2rem;
            color: #78DFA2;
        }
    }
    .contentArea {
        width: calc(100% - 6.6rem);
        margin: 0rem 3.3rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .news-title {
            width: 100%;
            margin-top: 2.5rem;
            text-align: left;
            font-size: 1.7rem;
            line-height: 2.2rem;
            color: #333333;
            font-weight: 600;
        }
        .news-text {
            width: 100%;
            margin-top: 1.3rem;
            text-align: left;
            font-size: 1.3rem;
            line-height: 2.2rem;
            color: #333333;
            opacity: 0.8;
        }
        .news-unordered {
            width: 100%;
            margin-top: 1.3rem;
            text-align: left;
            font-size: 1.3rem;
            line-height: 2.2rem;
            color: rgba(51, 51, 51, 0.8);
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .textIcon {
                display: inline-block;
                width: 0.7rem;
                height: 0.7rem;
                border-radius: 100%;
                background-color: #78DFA2;
                margin-right: 0.8rem;
            }
        }
    }
}
</style>